export const formatSessionData = (session = {}) => {
  const {
    accessToken: sessionAccessToken = '',
    identityToken: xIdToken = '',
    userInfo = {},
  } = session || {}
  const {
    accessToken = sessionAccessToken,
    company = '',
    displayname = '',
    email = '',
    firstName = '',
    fullName = '',
    lanId = '',
    lastName = '',
    memberOf = [],
    title = '',
  } = userInfo || {}

  return {
    accessToken,
    company,
    displayName: displayname,
    email,
    firstName,
    fullName,
    lanId,
    lastName,
    memberOf: Array.isArray(memberOf) ? memberOf : [],
    title,
    xIdToken,
  }
}
